var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureCommunicationLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9977 15.9609C14.9609 15.9609 14.9181 15.9609 14.8752 15.9671C14.4345 16.016 14.0734 16.3649 14.006 16.7995C13.9448 17.1729 14.0917 17.5157 14.3488 17.73L14.0856 19.0093C14.055 19.1501 14.1652 19.2847 14.3121 19.2847H14.9915H15.671C15.8179 19.2847 15.922 19.1501 15.8975 19.0093L15.6404 17.7422C15.8669 17.5586 16.0077 17.277 16.0077 16.9648C16.0015 16.4078 15.5547 15.9609 14.9977 15.9609Z",
    fill: "#0BA9E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0341 9.43555C14.9545 9.43555 14.8688 9.44167 14.7831 9.44779C13.4487 9.57634 12.457 10.7455 12.457 12.086V13.6041H17.605H17.6111L17.605 12.0126C17.6111 10.5925 16.4542 9.43555 15.0341 9.43555Z",
    fill: "#0BA9E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9969 1.85156C6.71496 1.85156 0 7.74016 0 14.9999C0 18.1278 1.24872 21.0048 3.33605 23.2635C2.95042 24.3041 2.24648 25.4794 0.96715 26.3241C0.648847 26.5322 0.746786 27.0219 1.1263 27.077C2.4546 27.2607 4.74393 27.3035 6.85574 26.0364C9.20016 27.3708 11.9976 28.1482 15.0031 28.1482C23.285 28.1482 30 22.2596 30 14.9999C30 7.74016 23.2789 1.85156 14.9969 1.85156ZM20.8488 20.3988C20.8488 21.066 20.3101 21.6047 19.6429 21.6047H10.3509C9.68374 21.6047 9.14507 21.066 9.14507 20.3988V14.8101C9.14507 14.1429 9.68374 13.6043 10.3509 13.6043H10.455V12.1229C10.455 9.64385 12.3771 7.53204 14.8562 7.44022C14.9174 7.44022 14.9725 7.4341 15.0337 7.4341C17.5556 7.4341 19.6123 9.4847 19.6123 12.0128V13.6043H19.6429C20.3101 13.6043 20.8488 14.1429 20.8488 14.8101V20.3988Z",
    fill: "#0BA9E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureCommunicationLogo);
export default __webpack_public_path__ + "static/media/secure_communication_logo.16d082dc3f03b2bd5a855237f9f43996.svg";
export { ForwardRef as ReactComponent };